// WP6-B.5 — Marketing Website single admin page with three tabs.
//
// Mounted at `/admin/marketing-website`. The admin shell (AdminLayout)
// handles nav + session guard; this component owns only the tab state.
import React, { useState } from "react";
import { usePageMeta } from "../../components/Layout";
import MarketingProjects from "./marketing/MarketingProjects";
import MarketingAbout from "./marketing/MarketingAbout";
import MarketingSiteImages from "./marketing/MarketingSiteImages";

const TABS = [
    { key: "projects", label: "Projects", render: MarketingProjects },
    { key: "about", label: "About", render: MarketingAbout },
    { key: "site_images", label: "Site Images", render: MarketingSiteImages },
];

export default function MarketingWebsite() {
    usePageMeta({ title: "Marketing Website | Studio G4 Admin" });
    const [activeTab, setActiveTab] = useState("projects");
    const Active = (TABS.find((t) => t.key === activeTab) || TABS[0]).render;
    return (
        <div data-testid="marketing-website-page">
            <div className="border-b border-[#E5E5E5] bg-white px-8 md:px-12 pt-6">
                <h2 className="font-['Outfit'] text-xs tracking-[0.2em] uppercase text-[#9A8B7E]">Marketing Website</h2>
                <nav
                    aria-label="Marketing Website sections"
                    className="flex gap-6 mt-3 -mb-px"
                    data-testid="marketing-website-tabs"
                >
                    {TABS.map((t) => {
                        const active = t.key === activeTab;
                        return (
                            <button
                                key={t.key}
                                type="button"
                                data-testid={`marketing-tab-${t.key}`}
                                onClick={() => setActiveTab(t.key)}
                                className={`py-3 text-sm tracking-wide font-medium border-b-2 transition-colors ${
                                    active
                                        ? "border-[#0A0A0A] text-[#0A0A0A]"
                                        : "border-transparent text-[#525252] hover:text-[#0A0A0A]"
                                }`}
                            >
                                {t.label}
                            </button>
                        );
                    })}
                </nav>
            </div>
            <Active />
        </div>
    );
}
